import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 40px 0;
`;

export const Row = styled.div`
	display: flex;
	height: 48px;
	padding: 0 12px;
	align-items: center;
	border-top: 1px solid ${colors.grey4};
	background-color: white;

	&:last-child {
		border-bottom: 1px solid ${colors.grey4};
	}
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 24px;
	padding: 0 16px;
	color: ${colors.grey8};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ onClick }) =>
		onClick &&
		css`
			color: ${colors.green2};
			cursor: pointer;

			&:hover {
				color: ${colors.green3};
			}
		`};
`;

export const Helper = styled.div`
	color: black;
	font-size: 11px;
	line-height: 13px;
	padding: 0 8px;
`;
